import { StateType } from 'data/types'

export const getSubmittedDeposit = (state: StateType) => state.payments.submitDeposit.data

export const isSubmitting = (state: StateType) => state.payments.submitDeposit.loading

export const getError = (state: StateType) => state.payments.submitDeposit.error
